import { Input } from '@angular/core';
import { FilterFieldValue } from '../covance-filter.models';
import { CovanceFilterBaseType} from './covance-filter-base-type';

export class CovanceFilterBaseTypeComponent<TFilterType extends CovanceFilterBaseType> {
    @Input()
    public fieldVal: FilterFieldValue;

    public get width(): string {
        return this.fieldVal.def.width != null ? `${this.fieldVal.def.width}px` : null;
    }

    protected filterType: TFilterType;

    constructor(filterType: TFilterType) {
        this.filterType = filterType;
    }

    public onFieldChange($event: string) {
        this.fieldVal.value = $event;
        this.filterType.setQueryParamValue(this.fieldVal);
        this.filterType.onFieldChange(this.fieldVal);
    }
}
